module.exports = __webpack_public_path__ + "media/5.b960d5e3.wav";